// Static option lists for PortalFieldDefinition — mirror the backend constants
// (AppBundle\Entity\PortalFieldDefinition); no OPTIONS endpoint needed.

export const ENTITY_TYPE_OPTIONS = [
    { key: 'order', value: 'Reise (Dashboard)' },
    { key: 'passenger', value: 'Teilnehmer' },
    { key: 'text', value: 'Texte (Reise)' },
];

export const TYPE_OPTIONS = [
    { key: 'text', value: 'Text' },
    { key: 'number', value: 'Zahl' },
    { key: 'date', value: 'Datum' },
    { key: 'select', value: 'Auswahl' },
    { key: 'boolean', value: 'Ja/Nein' },
    // richtext is meant for the Texte tab (entityType=text); on the dashboard
    // it would fall back to a plain text input.
    { key: 'richtext', value: 'Formatierter Text' },
    // Several options ticked at once (value = string array). Order fields only;
    // edited in the portal's trip form.
    { key: 'checkboxes', value: 'Mehrfachauswahl (Checkboxen)' },
];

export const SOURCE_OPTIONS = [
    { key: 'manual', value: 'manuell (Kunde trägt ein)' },
    { key: 'computed', value: 'berechnet (Resolver)' },
];

// Static option lists for PortalTodoTemplate — mirror the backend constants
// (AppBundle\Entity\PortalTodoTemplate::$dueDateModeList).

export const PORTAL_TODO_DUE_MODE_OPTIONS = [
    { key: 'before_start', value: 'X Tage vor Reisebeginn' },
    { key: 'after_create', value: 'X Tage nach Anlage der Reise' },
    { key: 'none', value: 'Ohne Datum (Checkliste)' },
];

// Human-readable Fälligkeit for the templates table, so the section and the form
// never describe the same row differently.
export const portalTodoDueLabel = function (template) {
    if (!template || template.dueDateMode === 'none') {
        return 'ohne Datum';
    }
    const days = template.daysOffset === null || template.daysOffset === undefined ? '?' : template.daysOffset;
    return template.dueDateMode === 'before_start'
        ? `${days} Tage vor Reisebeginn`
        : `${days} Tage nach Anlage`;
};

// Whether a passenger field is a built-in Passenger column (source=entity) or a
// client-specific custom field (source=manual/computed). Only relevant on the
// passenger level — order-level fields are always custom.
export const FIELD_KIND_OPTIONS = [
    { key: 'standard', value: 'Standardfeld' },
    { key: 'custom', value: 'Eigenes Feld' },
];

// Selectable built-in Passenger fields for source=entity definitions. key is the
// Passenger property (read/written directly, not via customFieldValues); type is
// only a label hint here — the actual cell renderer comes from ENTITY_COLUMNS in
// pages/clientPortal/order/participants/passengerColumns.js. Mirrors the backend
// PortalFieldDefinition::ENTITY_PASSENGER_FIELDS whitelist.
export const ENTITY_PASSENGER_FIELDS = [
    { key: 'firstName',          label: 'Vorname',            type: 'text' },
    { key: 'lastName',           label: 'Nachname',           type: 'text' },
    { key: 'gender',             label: 'Geschlecht (M/W)',   type: 'select' },
    { key: 'dateOfBirth',        label: 'Geburtstag',         type: 'date' },
    { key: 'placeOfBirth',       label: 'Geburtsort',         type: 'text' },
    { key: 'birthCountry',       label: 'Geburtsland',        type: 'select' },
    { key: 'nationality',        label: 'Nationalität',       type: 'select' },
    { key: 'documentType',       label: 'Pass-Art',           type: 'select' },
    { key: 'documentNumber',     label: 'Pass/ID-Nummer',     type: 'text' },
    { key: 'passExpirationDate', label: 'Pass gültig bis',    type: 'date' },
    { key: 'allergies',          label: 'Allergie/Ernährung', type: 'text' },
    { key: 'assistance',         label: 'Hilfebedarf',        type: 'boolean' },
    { key: 'outsideCabin',       label: 'Außenkabine',        type: 'boolean' },
    { key: 'motorBike',          label: 'Motorrad',           type: 'text' },
    { key: 'licencePlate',       label: 'Kennzeichen',        type: 'text' },
    { key: 'notes',              label: 'Bemerkung',          type: 'text' },
];
